<template>
	<div class="experience-booker">
		<div class="header">
			<div class="title">{{ reservationsStore.selectedExperience.name }}</div>
			<div class="subtitle" v-if="reservationsStore.selectedExperience.description">{{ reservationsStore.selectedExperience.description }}</div>
		</div>
		<div class="steppers">
			<ExperienceStepper :current-step="currentStep" />
		</div>
        <div class="body">
            <DateChooser v-if="currentStep === 1" />
			<TimeChooser v-if="currentStep === 2" />
			<PeopleChooser v-if="currentStep === 3" />
			<ReservationData v-if="currentStep === 4" />
			<ReservationConfirmation v-if="currentStep === 5" />
        </div>
		<div class="info-container" v-if="menusStore.business.options.reservations_info">
			<p>{{ menusStore.business.options.reservations_info }}</p>
		</div>
	</div>
</template>

<script>
import {useReservationsStore} from "@/book/stores";
import {useMenusStore} from "@/new-menu/stores";
import ExperienceStepper from "@/book/components/ExperienceStepper.vue";
import DateChooser from "@/book/components/DateChooser.vue";
import TimeChooser from "@/book/components/TimeChooser.vue";
import PeopleChooser from "@/book/components/PeopleChooser.vue";
import ReservationData from "@/book/components/ReservationData.vue";
import ReservationConfirmation from "@/book/components/ReservationConfirmation.vue";

export default {
	setup() {
		const reservationsStore = useReservationsStore();
		const menusStore = useMenusStore();
		return {reservationsStore, menusStore};
	},
	components: {ReservationConfirmation, ReservationData, PeopleChooser, TimeChooser, DateChooser, ExperienceStepper},
	name: "ExperienceBooker",
	data() {
		return {
		}
	},
	computed: {
        currentStep() {
            if(!this.reservationsStore.chosenDate) {
                return 1;
			} else if(!this.reservationsStore.chosenTime.time) {
				return 2;
			} else if(!this.reservationsStore.chosenPeople) {
				return 3;
			} else if(!this.reservationsStore.confirmedReservationId) {
				return 4;
			} else {
				return 5;
            }
        },
	},
}
</script>

<style scoped lang="scss">
.experience-booker {
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	width: 100%;
	padding-top: var(--padding-vertical);

	.header {
		display: flex;
		flex-direction: column;
		align-items: flex-start;
		width: 100%;
		padding: var(--padding-vertical) var(--padding-horizontal);
		gap: calc(var(--padding-vertical) / 2);

		.title {
			font-size: var(--font-size-xxxl);
			font-weight: 700;
			color: var(--theme-txt1-color);
		}

		.subtitle {
			font-size: var(--font-size);
			color: var(--theme-txt2-color);
		}
	}

	.steppers {
        padding: 0 var(--padding-horizontal);
		width: 100%;
	}

    .body {
        display: flex;
        justify-content: center;
        align-items: center;
        padding: 0 var(--padding-horizontal);
        margin-top: var(--padding-vertical);
        width: 100%;
    }

	.info-container {
		display: flex;
		align-items: center;
		justify-content: flex-start;
		width: 100%;
		padding: var(--padding-vertical) var(--padding-horizontal);
		margin-top: var(--padding-vertical);

		p {
			font-size: var(--font-size);
			color: var(--theme-txt2-color);
		}
	}
}
</style>